import ReactECharts, { EChartsOption } from 'echarts-for-react';
import { useWidthSize } from '../../../../core/hooks/useWidthSize';
import { useRef } from 'react';

type GradientBarChartProps = {
  options: EChartsOption;
};

export default function GradientBarChart(props: GradientBarChartProps) {
  const width = useWidthSize();

  const { options, ...restProps } = props;
  const eCharts = useRef<ReactECharts | null>(null);

  return (
    <ReactECharts
      {...restProps}
      style={{
        width: '100%',
        height: '100%',
        paddingRight: '10px',
      }}
      notMerge={true}
      opts={{ locale: 'pt-br', renderer: 'svg' }}
      option={{
        ...options,
        grid: {
          containLabel: true,
          bottom: 10,
          left: 10,
          right: 10,
          top: '10%',
          ...options?.grid,
        },
      }}
      lazyUpdate={true}
      ref={(ref) => (eCharts.current = ref)}
    />
  );
}
